import { metricStatus } from "../lib/status";

// --- Icons (outline, 18px viewBox = 20) ----------------------------------
export const I = {
  dashboard: (p) => (
    <svg {...p} width={p?.width || 18} height={p?.height || 18} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2.5" y="2.5" width="6" height="6" rx="1.5" />
      <rect x="11.5" y="2.5" width="6" height="4" rx="1.5" />
      <rect x="2.5" y="11.5" width="6" height="6" rx="1.5" />
      <rect x="11.5" y="9.5" width="6" height="8" rx="1.5" />
    </svg>
  ),
  bell: (p) => (
    <svg {...p} width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 9a5 5 0 0 1 10 0v2.5l1.4 2.4a.5.5 0 0 1-.43.75H3.83a.5.5 0 0 1-.43-.75L5 11.5V9Z" />
      <path d="M8.2 17a2 2 0 0 0 3.6 0" />
    </svg>
  ),
  log: (p) => (
    <svg {...p} width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="14" height="14" rx="2" />
      <path d="M6 7.5h8M6 10.5h8M6 13.5h5" />
    </svg>
  ),
  search: (p) => (
    <svg {...p} width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="9" r="5" />
      <path d="m13 13 3.5 3.5" />
    </svg>
  ),
  plus: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 4v12M4 10h12" />
    </svg>
  ),
  trash: (p) => (
    <svg {...p} width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.5 5.5h13M8 5.5V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5M5.5 5.5l.7 10a1 1 0 0 0 1 .9h5.6a1 1 0 0 0 1-.9l.7-10" />
    </svg>
  ),
  edit: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.5 14.5V17h2.5L15.5 7.5l-2.5-2.5L3.5 14.5Z" />
      <path d="m12 6.5 2.5 2.5" />
    </svg>
  ),
  more: (p) => (
    <svg {...p} width="15" height="15" viewBox="0 0 20 20" fill="currentColor">
      <circle cx="4.5" cy="10" r="1.4" />
      <circle cx="10" cy="10" r="1.4" />
      <circle cx="15.5" cy="10" r="1.4" />
    </svg>
  ),
  close: (p) => (
    <svg {...p} width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="m5 5 10 10M15 5 5 15" />
    </svg>
  ),
  chevron: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="m7 5 5 5-5 5" />
    </svg>
  ),
  filter: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 4.5h14M5.5 9.5h9M8.5 14.5h3" />
    </svg>
  ),
  sun: (p) => (
    <svg {...p} width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10" cy="10" r="3.2" />
      <path d="M10 2.5v1.8M10 15.7v1.8M2.5 10h1.8M15.7 10h1.8M4.5 4.5l1.3 1.3M14.2 14.2l1.3 1.3M4.5 15.5l1.3-1.3M14.2 5.8l1.3-1.3" />
    </svg>
  ),
  moon: (p) => (
    <svg {...p} width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 11.6A6.5 6.5 0 0 1 8.4 4 6.5 6.5 0 1 0 16 11.6Z" />
    </svg>
  ),
  refresh: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.5 10A6.5 6.5 0 0 1 15 6" />
      <path d="M15 3.5V6h-2.5" />
      <path d="M16.5 10a6.5 6.5 0 0 1-11.5 4" />
      <path d="M5 16.5V14h2.5" />
    </svg>
  ),
  alert: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 3 2.5 16.5h15L10 3Z" />
      <path d="M10 8v3.5M10 14v.01" />
    </svg>
  ),
  cpu: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="5" width="10" height="10" rx="1.5" />
      <rect x="7.5" y="7.5" width="5" height="5" rx="0.6" />
      <path d="M8 2v3M12 2v3M8 15v3M12 15v3M2 8h3M2 12h3M15 8h3M15 12h3" />
    </svg>
  ),
  ram: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6.5" width="16" height="7" rx="1" />
      <path d="M5 9v2M8 9v2M11 9v2M14 9v2" />
    </svg>
  ),
  disk: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="10" cy="5.5" rx="6.5" ry="2" />
      <path d="M3.5 5.5v9c0 1.1 2.9 2 6.5 2s6.5-.9 6.5-2v-9" />
      <path d="M3.5 10c0 1.1 2.9 2 6.5 2s6.5-.9 6.5-2" />
    </svg>
  ),
  copy: (p) => (
    <svg {...p} width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="6" width="10" height="10" rx="1.5" />
      <path d="M4 13V5a1 1 0 0 1 1-1h8" />
    </svg>
  ),
  send: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 10 17 3.5l-3 13.5-3.5-5L3 10Z" />
      <path d="m10.5 12 3-3" />
    </svg>
  ),
  telegram: (p) => (
    <svg {...p} width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
      <path d="M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm3.91-11.7-1.39 6.55c-.1.46-.38.57-.78.36l-2.14-1.58-1.04 1c-.11.11-.21.21-.43.21l.15-2.18 3.96-3.57c.17-.15-.04-.24-.27-.09L7.07 10.6l-2.11-.66c-.46-.14-.47-.46.1-.68l8.24-3.18c.38-.14.71.09.59.72Z" />
    </svg>
  ),
  chevronDown: (p) => (
    <svg {...p} width="12" height="12" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m5 7 5 5 5-5" />
    </svg>
  ),
  check: (p) => (
    <svg {...p} width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m4.5 10 3.5 3.5 7.5-7.5" />
    </svg>
  ),
  xSmall: (p) => (
    <svg {...p} width="12" height="12" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m6 6 8 8M14 6l-8 8" />
    </svg>
  ),
};

// --- Sparkline ----------------------------------------------------------
export function Sparkline({ data, color, width = 56, height = 18 }) {
  if (!data || data.length < 2) {
    return <svg className="spark" width={width} height={height} />;
  }
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = Math.max(max - min, 1);
  const stepX = width / (data.length - 1);
  const points = data
    .map((v, i) => {
      const x = i * stepX;
      const y = height - 2 - ((v - min) / range) * (height - 4);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
  const last = data[data.length - 1];
  const lx = width;
  const ly = height - 2 - ((last - min) / range) * (height - 4);
  return (
    <svg className="spark" width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <polyline
        fill="none"
        stroke={color || "currentColor"}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        points={points}
        opacity="0.85"
      />
      <circle cx={lx - 1} cy={ly} r="1.6" fill={color || "currentColor"} />
    </svg>
  );
}

// --- Larger area chart for the process panel ----------------------------
export function AreaChart({ data, color, width = 480, height = 60 }) {
  if (!data || data.length < 2) return <svg className="proc-chart-svg" />;
  const min = 0;
  const max = 100;
  const range = max - min;
  const stepX = width / (data.length - 1);
  const pts = data.map((v, i) => {
    const x = i * stepX;
    const y = height - 4 - ((v - min) / range) * (height - 8);
    return { x, y };
  });
  const linePath = pts
    .map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(1)} ${p.y.toFixed(1)}`)
    .join(" ");
  const areaPath = linePath + ` L ${width} ${height} L 0 ${height} Z`;
  const gradId = `grad-${color?.replace(/[^a-z0-9]/gi, "")}-${Math.random().toString(36).slice(2, 7)}`;
  return (
    <svg className="proc-chart-svg" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
      <defs>
        <linearGradient id={gradId} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.32" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={areaPath} fill={`url(#${gradId})`} />
      <path d={linePath} fill="none" stroke={color} strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}

// --- Metric cell (bar + percent) ----------------------------------------
export function MetricCell({ value, threshold }) {
  if (value == null) {
    return (
      <div className="metric">
        <div className="metric-bar"><div className="metric-bar-fill" style={{ width: 0 }} /></div>
        <span className="metric-val" data-status="offline">—</span>
      </div>
    );
  }
  const status = metricStatus(value, threshold);
  return (
    <div className="metric">
      <div className="metric-bar">
        <div className="metric-bar-fill" data-status={status} style={{ width: `${Math.min(value, 100)}%` }} />
      </div>
      <span className="metric-val" data-status={status}>{Math.round(value)}%</span>
    </div>
  );
}

// --- Status badge ------------------------------------------------------
export function StatusBadge({ status }) {
  const labels = { ok: "Aman", warn: "Mendekati", crit: "Over Limit", offline: "Offline" };
  return <span className="status-badge" data-status={status}>{labels[status]}</span>;
}

// --- Toggle switch ----------------------------------------------------
export function Toggle({ on, onChange, label }) {
  return (
    <button className="toggle" data-on={on} onClick={() => onChange(!on)}>
      <span className="toggle-switch" />
      {label && <span style={{ fontSize: 13 }}>{label}</span>}
    </button>
  );
}
